import { useEffect, useState } from "react";
import { ListBox } from "style/admin/review";
import AdminReviewTable from "./admin.review.table";
import { fetchLoadReviewList } from "api/admin/review";
import { AdminReviewDto, ReviewParams } from "interface/admin/interface.review";

interface ListProps {
  searchTerm: string;
  setDataLength?: any;
  reportCount?: number;
  hideYn?: "Y" | "N" | null;
  bestYn?: "Y" | "N" | null;
}

const AdminReviewList = ({
  searchTerm,
  setDataLength,
  reportCount = 0,
  hideYn = null,
  bestYn = null,
}: ListProps) => {
  const [data, setData] = useState<AdminReviewDto[]>([]);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    const loadReportAccumulationReview = async () => {
      try {
        const params: ReviewParams = {
          keyword: searchTerm,
          orderBy: "REGDT",
          orderByDir: "DESC",
          reportCount: reportCount,
          hideYn: hideYn,
          bestYn: bestYn,
        };
        const response = await fetchLoadReviewList(params);

        setData(response.result || []);
        setDataLength(response.result.length > 0);
      } catch (error) {
        console.error(error);
      } finally {
        setIsLoading(false);
      }
    };

    loadReportAccumulationReview();
  }, [searchTerm]);

  return (
    <ListBox>
      {isLoading ? (
        <p>검색 중...</p> // ✅ 로딩 표시
      ) : (
        <AdminReviewTable data={data} />
      )}
    </ListBox>
  );
};

export default AdminReviewList;
